import posthog from 'posthog-js';

/**
 * PostHog を初期化
 * 環境変数 REACT_APP_POSTHOG_API_KEY が設定されている場合のみ動作する
 */
export function initPostHog() {
  const apiKey = process.env.REACT_APP_POSTHOG_API_KEY;
  const apiHost = process.env.REACT_APP_POSTHOG_HOST;

  if (!apiKey) {
    console.warn('PostHog: REACT_APP_POSTHOG_API_KEY が設定されていません');
    return null;
  }

  posthog.init(apiKey, {
    api_host: apiHost || 'https://us.i.posthog.com',
    ui_host: apiHost || 'https://us.posthog.com',
    capture_pageview: true,
    capture_pageleave: true,
    disable_session_recording: false,
    session_recording: {
      recordCrossOriginIframes: true,
    },
    enable_recording_console_log: true,
    feature_flag_request_timeout_ms: 10000,
  });

  return posthog;
}

/**
 * 初期化済みの PostHog インスタンスを取得
 * 未初期化の場合は null を返す
 */
export function getPostHog() {
  return posthog.__loaded ? posthog : null;
}
